import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnCircleCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m9.08 14.92 5.84-5.84m0 5.84L9.08 9.08M12 21c4.95 0 9-4.05 9-9s-4.05-9-9-9-9 4.05-9 9 4.05 9 9 9"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnCircleCross;
